import type {ToastVariant} from './toastTypes'

// Mirrors fe/gui/theme.ts dark tokens (common/ has no MUI access).
export const TOAST_COLORS: Record<ToastVariant, {bg: string; fg: string; accent: string}> = {
  success: {
    bg: 'rgba(20, 17, 31, 0.95)',
    fg: '#F5F3FF',
    accent: '#4ADE80',
  },
  error: {
    bg: 'rgba(28, 16, 22, 0.95)',
    fg: '#FFE4E4',
    accent: '#EF4444',
  },
  info: {
    bg: 'rgba(20, 17, 31, 0.95)',
    fg: '#F5F3FF',
    accent: '#7C5CFF',
  },
}
